import { createSelector } from '@ngrx/store';
import { getRmsSpecificationPage } from './index';
import {
  filterConcreteExtraProducts,
  filterConcreteProductsOrNoTValue,
} from '@ordersnproducts/utils/order-filters-helper';

export const getProductsState = createSelector(getRmsSpecificationPage, (state) => state.productsLegacyState);
export const getOpenPlatformProductsState = createSelector(
  getRmsSpecificationPage,
  (state) => state.productsOpenPlatformState,
);

export const getIsContractProductLoading = createSelector(getProductsState, (state) => state.loading);
export const getOpenPlatformIsProductLoading = createSelector(getOpenPlatformProductsState, (state) => state.loading);

export const getAvailableProducts = createSelector(getProductsState, (state) => state.availableProducts);
export const getOpenPlatformProducts = createSelector(getOpenPlatformProductsState, (state) =>
  state.availableProducts?.filter(filterConcreteProductsOrNoTValue),
);

export const getOpenPlatformExtraProducts = createSelector(getOpenPlatformProductsState, (state) =>
  state.availableProducts?.filter(filterConcreteExtraProducts),
);

export const getOpenPlatformExtraProductsReady = createSelector(getOpenPlatformProductsState, (state) => {
  return {
    ready: state.availableProducts.length > 0,
    products: state.availableProducts?.filter(filterConcreteExtraProducts),
  };
});

export const getOpenPlatformUnitsByProductMap = createSelector(
  getOpenPlatformProductsState,
  (state) => state.unitByProductMap,
);
